// Utility helpers shared across UniBuy™ components
export const COUNTRY_FLAGS = {
  NL: "🇳🇱", DE: "🇩🇪", FR: "🇫🇷", IT: "🇮🇹", ES: "🇪🇸", GB: "🇬🇧", UK: "🇬🇧",
  US: "🇺🇸", CA: "🇨🇦", IN: "🇮🇳", JP: "🇯🇵", CN: "🇨🇳", BR: "🇧🇷", AU: "🇦🇺",
  MX: "🇲🇽", SG: "🇸🇬", AE: "🇦🇪", SA: "🇸🇦", ZA: "🇿🇦", CH: "🇨🇭", SE: "🇸🇪",
  NO: "🇳🇴", DK: "🇩🇰", FI: "🇫🇮", BE: "🇧🇪", AT: "🇦🇹", IE: "🇮🇪", PT: "🇵🇹",
  PL: "🇵🇱",
};

export const CURRENCY_SYMBOL = {
  EUR: "€", USD: "$", GBP: "£", INR: "₹", JPY: "¥", CHF: "CHF", AUD: "A$", CAD: "C$",
  BRL: "R$", CNY: "CN¥",
};

export const COUNTRY_BY_CODE = {
  NL: { name: "Netherlands", dial: "+31", currency: "EUR" },
  DE: { name: "Germany", dial: "+49", currency: "EUR" },
  FR: { name: "France", dial: "+33", currency: "EUR" },
  GB: { name: "United Kingdom", dial: "+44", currency: "GBP" },
  US: { name: "United States", dial: "+1", currency: "USD" },
  IN: { name: "India", dial: "+91", currency: "INR" },
  JP: { name: "Japan", dial: "+81", currency: "JPY" },
  SG: { name: "Singapore", dial: "+65", currency: "SGD" },
  AE: { name: "United Arab Emirates", dial: "+971", currency: "AED" },
  CH: { name: "Switzerland", dial: "+41", currency: "CHF" },
  BR: { name: "Brasil", dial: "+55", currency: "BRL" },
  CN: { name: "China", dial: "+86", currency: "CNY" },
};

export const COUNTRIES = Object.entries(COUNTRY_BY_CODE).map(([code, info]) => ({
  code,
  ...info,
}));

export const TITLES = [
  "Buyer",
  "Procurement Officer",
  "MRO Specialist",
  "Production Lead",
  "Sourcing Lead",
  "General Employee",
  "Contractor",
  "Other",
];

export function fmtCurrency(amount, currency = "EUR") {
  if (amount === null || amount === undefined) return "—";
  const sym = CURRENCY_SYMBOL[currency] || currency + " ";
  return `${sym}${Number(amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const ORDER_STATUSES = [
  "Pending PO",
  "Pending PO Acceptance",
  "Pending Shipment",
  "Shipped",
  "Delivered",
];

export function isBusinessEmail(email) {
  const personal = [
    "gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com",
    "aol.com", "live.com", "proton.me", "protonmail.com", "ymail.com", "msn.com",
  ];
  const m = /^[^\s@]+@([^\s@]+\.[^\s@]+)$/.exec((email || "").trim().toLowerCase());
  if (!m) return false;
  return !personal.includes(m[1]);
}
